import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 323,
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
}));

export default useStyles;
